var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"hidden-sm-and-down",attrs:{"size":"14"},domProps:{"textContent":_vm._s('$mdiChevronDown')}})
}
var staticRenderFns = []

export { render, staticRenderFns }